import { PubSubService } from './../service/pubSub.service';
import { socialService } from '../services/social/social.service';
/**
* Model import Example :
* import { HERO } from '../models/hero.model.ts';
*/
var missioncontrolComponent = (function () {
    /**
     * socialService got getting mission control data
     * pubsub to subscribe to the timer
     */
    function missioncontrolComponent(socialService, pubsub) {
        var _this = this;
        this.socialService = socialService;
        this.pubsub = pubsub;
        this.chartsData = {}; // both chart byCategory and byProduct will be part of this object sent by the server
        /**
        *  Subscribe to the getData event
        */
        this.getDataSub = this.pubsub.$sub('getData', function (eventObject) {
            _this.getMissionControl();
        });
    }
    /**
     * 1. get mission control data service call
     */
    missioncontrolComponent.prototype.ngOnInit = function () {
        this.getMissionControl();
    };
    missioncontrolComponent.prototype.ngOnChanges = function (changes) {
        if (changes['tabChange'] && changes['tabChange'].currentValue === 0) {
            this.getMissionControl();
        }
    };
    /**
     * Do all the require check and initialization in this method
     * before making the mission control data service call
     */
    missioncontrolComponent.prototype.getMissionControl = function () {
        var _this = this;
        this.chartsData = {};
        this.socialService.getMissionControl().subscribe(function (result) {
            _this.chartsData = result;
        }, function (error) {
            console.log(error);
        });
    };
    /**
     * 1. unsubscribe the timer before the component is destroyed
    */
    missioncontrolComponent.prototype.ngOnDestroy = function () {
        this.getDataSub.unsubscribe();
    };
    return missioncontrolComponent;
}());
export { missioncontrolComponent };



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/missioncontrolComponent/missioncontrol.component.ts.pre-build-optimizer.js